module.exports = __webpack_public_path__ + "img/JuanIgnacioPucci.e7e2ba7a.png";